export default __webpack_public_path__ + "static/media/Inter-UI-BoldItalic.83366532.woff2";